
import Vue from 'vue'
export default Vue.extend({
  scrollToTop: true,
  data() {
    return {
      logo: require('../assets/heybirdie/logo.webp'),
      notion: require('../assets/heybirdie/notion.webp'),
      zeplin: require('../assets/heybirdie/zeplin.webp'),
      heybirdie: require('../assets/heybirdie/heybirdie.co.kr_.webp'),
      review: require('../assets/heybirdie/review.webp'),
      mpf: require('../assets/heybirdie/mpf.webp'),
      distence0: require('../assets/heybirdie/distence0.webp'),
      distence1: require('../assets/heybirdie/distence1.webp'),
      distence2: require('../assets/heybirdie/distence2.webp'),
      color: require('../assets/heybirdie/color.webp'),
    }
  },
  head() {
    return {
      title: '대표 프로젝트',
    }
  },
})
